import * as React from 'react';
import './FilesAndReportsList.scss'
import { FC, useMemo, useCallback, useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader, NavLink, Popover, PopoverBody } from 'reactstrap';
import { getEntitiesDataItems, getFilesForClient, getReportsForClient, isLoadingEntities } from '../../store/entities/selectors';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import Assignment from "@material-ui/icons/Assignment";
import AttachFile from "@material-ui/icons/AttachFile";
import Ballot from "@material-ui/icons/Ballot";
import MailOutline from '@material-ui/icons/MailOutline';
import FilterListIcon from '@material-ui/icons/FilterList';
import MicIcon from '@material-ui/icons/Mic';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { IconButton, Popover as MuiPopover } from '@material-ui/core';
import { getIconComponent } from '../../shared/documentIconPicker';
import { AppointmentData, ClientReportsAndFiles, DocumentSettings, FeatureEnum, PermissionEnum, SurveyHistoryItem, TaskItemData, TaskItemStatus, TaskItemType } from '../../models';
import Typography from '../Typography';
import { Report, ReportFieldFlag, ReportFieldType } from '../../models';
import { ReportSettings, ReportTemplateData } from '../../models/api-models';
import { createReport, deleteEntity, entityEditing, fetchClientReportsAndFiles } from '../../store/entities/actions';
import { getClient } from '../../store/entities/selectors';
import Delete from '@material-ui/icons/Delete'
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import ShareIcon from '@mui/icons-material/Share';
import { Tooltip } from '@material-ui/core';
import { deleteClientFileAsync, deleteClientReportAsync, sendClientFileByEmailAsync, updateClientFileShareAsync, updateClientReportShareAsync, updateTaskStatusAsync, sendClientReportByEmailAsync } from '../../ajax/requests';
import { ClientFile } from '../../models';
import { getFeatures, getMyUser, getMyProffesionalData, isAdministrator } from '../../store/session/selectors';
import { daysBetween } from '../../shared/utils';
import { getClientsLoginSettings, getCompanyLogo, getDocumentsSettings } from '../../store/settings/selectors';
import { useReportTemplates } from '../../hooks/useReportTemplates';
import ReportHeader from '../Forms/ReportForm/ReportHeader';
import ReportFormContent from '../Forms/ReportForm/ReportFormContent';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { genericFileSettings, UploadFileModal } from '../UploadFileModal';
import TaskCreateModal from '../Tasks/TaskCreateModal';
import { TextInputField } from '../Forms/fields';
import TaskCompleteDialog from '../Tasks/TaskCompleteDialog';
import { canManageTasks, canUpdateTask, getTaskStatusTranslationKey, getTaskTypeIcon, getTaskTypeTranslationKey, hasVisibleTaskManagementScope, TaskDismissReasons, taskTypesForCreation } from '../../pages/Tasks/taskUtils';
import { getTasksUpdatedAt } from '../../store/general/selectors';
import styled from 'styled-components';
import moment from 'moment';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { SendSurveyModal, useSendSurveyAction } from '../Surveys/useSendSurveyAction';
import { ClientEntity } from 'src/store/entities/state';
import ToolTip from '../ToolTip';
import { alertError, alertSuccess } from '../../store/alerts/actions';
import { getErrorMessage } from '../../ajax/errors';
import AppButton from '../AppButton';
import { fetchPrescriptionsByClient } from '../../store/entities/actions';
import { getPrescriptionsByClient } from '../../store/entities/selectors';
import { PrescriptionData, PrescriptionState } from '../../models';
import CreatePrescriptionModal from '../../pages/Clients/CreatePrescriptionModal';
import LocalPharmacy from '@material-ui/icons/LocalPharmacy';
import ShareOptionsModal from './ShareOptionsModal';
import { ShareOptions } from '../../models';
const PreviewContainer = styled.div`
    max-height: 400px;
    max-width: 75vw;
    overflow-y: auto;
`;

const PreviewField = styled('div')`
    margin-bottom: var(--spacer-XS);

    &:last-child {
        margin-bottom: 0;
    }
`;

const PreviewLabel = styled.span`
    font-weight: bold;
    color: var(--text-body);
    margin-right: var(--spacer-XS);
`;

const PreviewValue = styled.span`
    color: var(--text-muted);
    white-space: pre-wrap;
    word-break: break-word;
`;

const PdfPreviewContainer = styled.div`
    width: 700px;
    height: 600px;
`;

const PdfPreview: FC<{ url: string }> = ({ url }) => (
    <PdfPreviewContainer>
        <iframe
            src={url}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="PDF Preview"
        />
    </PdfPreviewContainer>
);

const ImagePreviewContainer = styled.div`
    width: max-content;
    height: max-content;
    max-width: 600px;
    max-height: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ImagePreview: FC<{ url: string; fileName: string }> = ({ url, fileName }) => (
    <ImagePreviewContainer>
        <img
            src={url}
            alt={fileName}
            style={{ maxWidth: '100%', maxHeight: '400px', objectFit: 'contain' }}
        />
    </ImagePreviewContainer>
);

const ActiveTaskSummaryButton = styled(AppButton)`
    && {
        border: 0;
        background: none;
        text-align: left;
        text-transform: none;
        justify-content: flex-start;
        color: inherit;
        padding: 0;
        flex: 1;
        min-width: 0;
    }
`;

const ActiveTaskActions = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacer-XXS);
`;

const ActiveTaskActionButton = styled(IconButton)`
    && {
        padding: 0.25rem;
        color: var(--text-muted);
    }
`;

const TaskDetailsBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacer-S);
`;

const TaskDetailsActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: var(--spacer-XS);
`;

const FilterBar = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
    gap: var(--spacer-XS);
    margin-bottom: var(--spacer-XS);
    min-height: 34px;
`;

interface AddButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const AddButton = styled.button<AddButtonProps>`
    display: flex;
    align-items: center;
    align-self: stretch;
    gap: var(--spacer-XXS);
    color: var(--text-muted);
    border: var(--border-thin) solid var(--appLigthGrey);
    border-radius: var(--spacer-XS);
    padding: 0 var(--spacer-XS);
    background-color: transparent;
    cursor: pointer;
    font-size: 0.875rem;
    line-height: 1;
    &:hover {
        background-color: var(--bg-hover-light);
        color: var(--appBlue);
        border-color: var(--appBlue);
    }
`;

interface AddMenuOptionProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const AddMenuOption = styled.button<AddMenuOptionProps>`
    display: flex;
    align-items: center;
    gap: var(--spacer-XS);
    padding: var(--spacer-XXS) var(--spacer-XS);
    border-radius: var(--spacer-XS);
    cursor: pointer;
    background: none;
    border: none;
    font-size: 0.875rem;
    color: var(--text-body);
    text-align: left;
    width: 100%;
    &:hover {
        background-color: var(--bg-hover-light);
    }
`;

const FilterButton = styled(IconButton)<{ $active?: boolean }>`
    && {
        position: relative;
        color: ${({ $active }) => $active ? 'var(--appBlue)' : 'var(--text-muted)'};
        border: var(--border-thin) solid ${({ $active }) => $active ? 'var(--appBlue)' : 'var(--appLigthGrey)'};
        border-radius: var(--spacer-XS);
        padding: var(--spacer-XS);
        background-color: ${({ $active }) => $active ? 'var(--bg-hover-light)' : 'transparent'};
    }
`;

const FilterBadge = styled.span`
    position: absolute;
    top: -6px;
    right: -6px;
    background-color: var(--appBlue);
    color: white;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    font-size: 0.65rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    pointer-events: none;
`;

const FilterMenuContent = styled.div`
    padding: var(--spacer-S);
    min-width: 200px;
    max-height: 320px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;

const FilterSectionTitle = styled.div`
    font-size: 0.7rem;
    color: var(--text-muted);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: var(--spacer-XS) 0 var(--spacer-XXS);
    &:first-child {
        padding-top: 0;
    }
`;

interface FilterOptionProps {
    $selected?: boolean;
    onClick?: () => void;
    children?: React.ReactNode;
}

const FilterOption = styled.label<FilterOptionProps>`
    display: flex;
    align-items: center;
    gap: var(--spacer-XS);
    padding: var(--spacer-XXS) var(--spacer-XS);
    border-radius: var(--spacer-XS);
    cursor: pointer;
    background-color: ${({ $selected }) => $selected ? 'var(--bg-hover-light)' : 'transparent'};
    margin: 0;
    font-size: 0.875rem;
    color: var(--text-body);
    user-select: none;
    &:hover {
        background-color: var(--bg-hover-light);
    }
`;

const AiButton = styled.button`
    display: flex;
    align-items: center;
    align-self: stretch;
    gap: var(--spacer-XXS);
    color: var(--info-color);
    border: var(--border-thin) solid var(--info-color);
    border-radius: var(--spacer-XS);
    padding: 0 var(--spacer-XS);
    background-color: transparent;
    cursor: pointer;
    font-size: 0.8rem;
    line-height: 1;
    opacity: 0.85;
    &:hover {
        background-color: var(--bg-hover-light);
        opacity: 1;
    }
`;

interface ClearFilterButtonProps {
    onClick?: () => void;
    children?: React.ReactNode;
}

const ClearFilterButton = styled.button<ClearFilterButtonProps>`
    background: none;
    border: var(--border-thin) solid var(--appLigthGrey);
    border-radius: var(--spacer-XS);
    padding: var(--spacer-XXS) var(--spacer-XS);
    cursor: pointer;
    font-size: 0.75rem;
    color: var(--text-muted);
    margin-top: var(--spacer-S);
    align-self: flex-start;
`;

interface SurveyHistoryStatusProps {
    submitted: boolean;
    children: React.ReactNode;
}

const SurveyHistoryStatus: FC<SurveyHistoryStatusProps> = ({ submitted, children }) => (
    <span
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            width: 'fit-content',
            padding: 'var(--spacer-XXS) var(--spacer-XS)',
            borderRadius: '999px',
            fontSize: '0.72rem',
            fontWeight: 700,
            background: submitted ? 'var(--success-bg)' : 'var(--bg-light)',
            color: submitted ? 'var(--success-color)' : 'var(--text-muted)',
            border: `var(--border-thin) solid ${submitted ? 'var(--success-border)' : 'var(--appLigthGrey)'}`,
        }}
    >
        {children}
    </span>
);

const SurveyHistoryMeta = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacer-XS);
    align-items: center;
`;

const SurveyHistoryDetails = styled.div`
    margin-top: var(--spacer-XXS);
    display: flex;
    flex-direction: column;
    gap: var(--spacer-XXS);
`;

const SurveyHistoryHint = styled.div`
    display: flex;
    align-items: flex-start;
    gap: var(--spacer-XXS);
    color: var(--text-muted);
    font-size: 0.8em;
    white-space: normal;
`;

const SurveyHistoryAnswer: FC<{ children: React.ReactNode }> = ({ children }) => (
    <div style={{ whiteSpace: 'normal', color: 'var(--text-body)' }}>{children}</div>
);

const SurveyHistoryMetaText = styled.span`
    font-size: 0.8em;
    color: var(--text-muted);
`;

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];

const isImageFile = (fileName?: string): boolean => {
    if (!fileName) return false;
    const lowerName = fileName.toLowerCase();
    return IMAGE_EXTENSIONS.some(ext => lowerName.endsWith(ext));
};

interface DocumentEmailButtonProps {
    id: string;
    disabled: boolean;
    sending: boolean;
    tooltip: string;
    onClick: () => void;
}

const DocumentEmailButton: FC<DocumentEmailButtonProps> = ({
    id,
    disabled,
    sending,
    tooltip,
    onClick,
}) => {
    const button = (
        <AppButton
            id={disabled ? undefined : id}
            color="link"
            disabled={disabled || sending}
            onClick={onClick}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '3rem',
                height: '3rem',
                padding: 0,
                opacity: disabled || sending ? 0.55 : 1,
                backgroundColor: 'transparent',
                color: disabled || sending ? 'var(--text-muted)' : 'var(--appBlue)',
                border: 'none',
                boxShadow: 'none',
            }}
        >
            <MailOutline />
        </AppButton>
    );

    return disabled ? (
        <span id={id} style={{ display: 'inline-flex' }}>
            {button}
            <ToolTip target={id} toolTipContent={tooltip} />
        </span>
    ) : (
        <>
            {button}
            <ToolTip target={id} toolTipContent={tooltip} />
        </>
    );
};

interface ReportPreviewProps {
    report: Report;
    template?: ReportSettings;
}

const ReportPreview: FC<ReportPreviewProps> = ({ report, template }) => {

    const hideLabel = template?.fields.length === 1

    const entries = Object.entries(report.values || {})
        .filter(([_, value]) => !!value.length)
        .map(([key, value]) => ({key, value, field: template?.fields.find(f => f.label === key)}))
        .filter(({field}) => !field?.flags?.includes(ReportFieldFlag.ReadOnly) &&
            ![ReportFieldType.BlankSpace, ReportFieldType.ImageMarker, ReportFieldType.Signature, ReportFieldType.Separator].includes(field?.type ?? ReportFieldType.BlankSpace))
        // .slice(0, 10);

    if (!entries.length) {
        return <PreviewContainer><i>...</i></PreviewContainer>;
    }

    return (
        <PreviewContainer>
            {entries.map(({key, value, field}) => {
                return (
                    <PreviewField key={key}>
                        {!field?.flags?.includes(ReportFieldFlag.HideLabel) && !hideLabel && !field?.label.startsWith('auto-') && <PreviewLabel>{field?.label || key}:</PreviewLabel>}
                        <PreviewValue>{value || '-'}</PreviewValue>
                    </PreviewField>
                );
            })}
            {Object.keys(report.values || {}).length > 10 && (
                <PreviewField>
                    <PreviewValue><i>... +{Object.keys(report.values).length - 10} more fields</i></PreviewValue>
                </PreviewField>
            )}
        </PreviewContainer>
    );
};

interface FilterTypeOption {
    id: string;
    name: string;
    icon?: string;
    colorCode?: string;
    kind: 'report' | 'file' | 'task' | 'survey' | 'prescription';
    taskType?: TaskItemType;
}

const FILTER_COOKIE_KEY = 'filesReportsFilter';

const readFilterCookie = (): Set<string> => {
    const match = document.cookie.split(';').find(c => c.trim().startsWith(FILTER_COOKIE_KEY + '='));
    if (!match) return new Set();
    const value = match.split('=').slice(1).join('=').trim();
    return new Set(value.split(',').filter(Boolean));
};

const writeFilterCookie = (ids: Set<string>) => {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    document.cookie = `${FILTER_COOKIE_KEY}=${[...ids].join(',')};expires=${expires.toUTCString()};path=/`;
};

interface FilesAndResportsListProps {
    clientId: string
    showActiveTasksSection?: boolean
    showHistoryTitle?: boolean
    appointment?: AppointmentData,
    onOpenAiScriber?: () => void,
}

export const FilesAndResportsList: FC<FilesAndResportsListProps> = ({
    clientId,
    showActiveTasksSection = false,
    showHistoryTitle = false,
    appointment,
    onOpenAiScriber,
}) => {
    const t = useTranslations()
    const dispatch = useDispatch()

    const clients = useSelector(getEntitiesDataItems<ClientEntity>('clients'));
    const isAdmin = useSelector(isAdministrator)
    const myUser = useSelector(getMyUser)
    const myProfessional = useSelector(getMyProffesionalData)
    const features = useSelector(getFeatures)
    const client = useSelector(getClient(clientId))
    const reports = useSelector(getReportsForClient(clientId));
    const files = useSelector(getFilesForClient(clientId));
    const prescriptions = useSelector(getPrescriptionsByClient(clientId));
    const tasksUpdatedAt = useSelector(getTasksUpdatedAt);
    const { templates: reportsSettings } = useReportTemplates()
    const documentsSettings = useSelector(getDocumentsSettings)
    const loadingReports = useSelector(isLoadingEntities('reports'))
    const loadingFiles = useSelector(isLoadingEntities('files'))
    const loadingPrescriptions = useSelector(isLoadingEntities('prescriptions'))
    const [loadingTasks, setLoadingTasks] = useState(false)
    const loading = loadingFiles || loadingReports || loadingTasks || loadingPrescriptions
    const canCreateTask = Boolean(myUser && (canManageTasks(myUser) || myProfessional))
    const defaultTaskAssignedUserId = myProfessional ? myUser?.id : undefined
    const [surveyHistory, setSurveyHistory] = useState<SurveyHistoryItem[]>([])
    const [expandedSurveyHistoryId, setExpandedSurveyHistoryId] = useState<string | null>(null)

    const [deletingFileId, setDeletingFileId] = useState<undefined|string>(undefined)
    const [deletingReportId, setDeletingReportId] = useState<undefined|string>(undefined)
    const [sendingEmailItemId, setSendingEmailItemId] = useState<string | null>(null)
    const [reportForEmailPdf, setReportForEmailPdf] = useState<{ report: Report; template: ReportSettings; reportId: string } | null>(null)
    const emailPdfContainerRef = useRef<HTMLDivElement>(null)
    const [tasks, setTasks] = useState<TaskItemData[]>([])
    const [previewReportId, setPreviewReportId] = useState<string | null>(null)
    const [previewFileId, setPreviewFileId] = useState<string | null>(null)
    const [filterAnchor, setFilterAnchor] = useState<HTMLElement | null>(null)
    const [addAnchor, setAddAnchor] = useState<HTMLElement | null>(null)
    const [selectedTypeIds, setSelectedTypeIds] = useState<Set<string>>(readFilterCookie)
    const [showUploadModal, setShowUploadModal] = useState(false)
    const [showTaskCreateModal, setShowTaskCreateModal] = useState(false)
    const [taskTypeToCreate, setTaskTypeToCreate] = useState<TaskItemType>(TaskItemType.ReminderClientFollowUp)
    const [selectedTask, setSelectedTask] = useState<TaskItemData | null>(null)
    const [completeTask, setCompleteTask] = useState<TaskItemData | null>(null)
    const [detailsNotes, setDetailsNotes] = useState('')
    const [isUpdatingTask, setUpdatingTask] = useState(false)
    const [uploadDocType, setUploadDocType] = useState<string | undefined>(undefined)
    const [showCreatePrescription, setShowCreatePrescription] = useState(false)
    const [resultPrescription, setResultPrescription] = useState<PrescriptionData | null>(null)
    const [sharingItem, setSharingItem] = useState<{ id: string; type: 'report' | 'file'; share: ShareOptions | undefined } | null>(null)
    const hoverTimerRef = useRef<NodeJS.Timeout | null>(null)

    const handleReportMouseEnter = useCallback((reportId: string) => {
        hoverTimerRef.current = setTimeout(() => {
            setPreviewReportId(reportId)
        }, 1200)
    }, [])

    const handleReportMouseLeave = useCallback(() => {
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current)
            hoverTimerRef.current = null
        }
        setPreviewReportId(null)
    }, [])

    const handleFileMouseEnter = useCallback((fileId: string) => {
        hoverTimerRef.current = setTimeout(() => {
            setPreviewFileId(fileId)
        }, 1200)
    }, [])

    const handleFileMouseLeave = useCallback(() => {
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current)
            hoverTimerRef.current = null
        }
        setPreviewFileId(null)
    }, [])

    useEffect(() => {
        return () => {
            if (hoverTimerRef.current) {
                clearTimeout(hoverTimerRef.current)
            }
        }
    }, [])

    const loadClientTasks = useCallback(async () => {
        setLoadingTasks(true);
        try {
            const result = await (dispatch(fetchClientReportsAndFiles(clientId)) as unknown as Promise<ClientReportsAndFiles>)
            setTasks(result.tasks ?? []);
            setSurveyHistory(result.surveyHistory ?? []);
            if (features.includes(FeatureEnum.Prescriptions)) {
                await dispatch(fetchPrescriptionsByClient(clientId));
            }
        } catch {
            setTasks([]);
            setSurveyHistory([]);
        } finally {
            setLoadingTasks(false);
        }
    }, [clientId]);

    const sendSurveyAction = useSendSurveyAction(clientId, appointment?.id, client?.email, loadClientTasks);

    useEffect(() => {
        loadClientTasks();
    }, [loadClientTasks, tasksUpdatedAt]);

    const getSurveyFieldLabel = useCallback((surveyId: string, fieldKey: string) => {
        const survey = sendSurveyAction.surveys.find(item => item.id === surveyId);
        const fieldIndex = Number(fieldKey);

        if (survey && Number.isInteger(fieldIndex) && fieldIndex >= 0 && fieldIndex < survey.fields.length)
        {
            return survey.fields[fieldIndex].label;
        }

        return fieldKey;
    }, [sendSurveyAction.surveys]);

    const getSurveyHistorySubtext = useCallback((historyItem: SurveyHistoryItem) => {
        return [
            historyItem.professionalName,
            historyItem.serviceTypeName,
            historyItem.roomName,
            historyItem.branchName,
        ]
            .filter(value => Boolean(value?.trim().length))
            .join(' • ');
    }, []);

    const handleReportClick = useCallback((report: Report) => () => {
        dispatch(entityEditing('reports', report.id));
    }, [dispatch]);

    const handleSendFileByEmail = useCallback(async (fileId: string) => {
        if (!client?.email) {
            return;
        }

        const itemId = `file-${fileId}`;
        setSendingEmailItemId(itemId);
        try {
            await sendClientFileByEmailAsync(clientId, fileId);
            dispatch(alertSuccess(t(TK.sentSuccessfully)));
        } catch (error) {
            dispatch(alertError(getErrorMessage(error) || t(TK.somethingWentWrong)));
        } finally {
            setSendingEmailItemId(null);
        }
    }, [client?.email, clientId, dispatch, t]);

    const handleSendReportByEmail = useCallback(async (reportId: string) => {
        if (!client?.email) return;
        const report = reports?.find(r => r.id === reportId);
        if (!report) return;
        const template = reportsSettings.find(rs => rs.templateId === report.templateId);
        const itemId = `report-${reportId}`;
        setSendingEmailItemId(itemId);
        if (!template) {
            try {
                await sendClientReportByEmailAsync(clientId, reportId);
                dispatch(alertSuccess(t(TK.sentSuccessfully)));
            } catch (error) {
                dispatch(alertError(getErrorMessage(error) || t(TK.somethingWentWrong)));
            } finally {
                setSendingEmailItemId(null);
            }
            return;
        }
        setReportForEmailPdf({ report, template, reportId });
    }, [client?.email, clientId, dispatch, reports, reportsSettings, t]);

    useEffect(() => {
        if (!reportForEmailPdf || !emailPdfContainerRef.current) return;

        const { report, reportId } = reportForEmailPdf;

        const send = async () => {
            try {
                const element = emailPdfContainerRef.current!;
                let pdfFile: File;

                try {
                    // Convert all external image src values to base64 so html2canvas
                    // can draw them without the canvas being cross-origin tainted.
                    const imgElements = Array.from(element.querySelectorAll<HTMLImageElement>('img'));
                    await Promise.all(imgElements.map(async img => {
                        if (!img.src || img.src.startsWith('data:') || img.src.startsWith('blob:')) return;
                        try {
                            const res = await fetch(img.src, { mode: 'cors' });
                            const blob = await res.blob();
                            img.src = await new Promise<string>((resolve, reject) => {
                                const reader = new FileReader();
                                reader.onload = () => resolve(reader.result as string);
                                reader.onerror = reject;
                                reader.readAsDataURL(blob);
                            });
                        } catch {
                            img.src = '';
                        }
                    }));
                    await Promise.all(imgElements.map(img =>
                        img.complete ? Promise.resolve() : new Promise<void>(res => { img.onload = () => res(); img.onerror = () => res(); })
                    ));

                    const canvas = await html2canvas(element, { useCORS: true, scale: 2, backgroundColor: '#ffffff' });
                    const pdf = new jsPDF({ unit: 'pt', format: 'a4' });
                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = pdf.internal.pageSize.getHeight();
                    const imgData = canvas.toDataURL('image/jpeg', 0.92);
                    const imgHeight = (canvas.height * pageWidth) / canvas.width;

                    let heightLeft = imgHeight;
                    let yPos = 0;
                    pdf.addImage(imgData, 'JPEG', 0, yPos, pageWidth, imgHeight);
                    heightLeft -= pageHeight;
                    while (heightLeft > 0) {
                        yPos -= pageHeight;
                        pdf.addPage();
                        pdf.addImage(imgData, 'JPEG', 0, yPos, pageWidth, imgHeight);
                        heightLeft -= pageHeight;
                    }

                    const pdfBlob = pdf.output('blob');
                    pdfFile = new File([pdfBlob], `${report.name}.pdf`, { type: 'application/pdf' });
                } catch {
                    try {
                        await sendClientReportByEmailAsync(clientId, reportId);
                        dispatch(alertSuccess(t(TK.sentSuccessfully)));
                    } catch (fallbackError) {
                        dispatch(alertError(getErrorMessage(fallbackError) || t(TK.somethingWentWrong)));
                    }
                    return;
                }

                await sendClientReportByEmailAsync(clientId, reportId, pdfFile);
                dispatch(alertSuccess(t(TK.sentSuccessfully)));
            } catch (error) {
                dispatch(alertError(getErrorMessage(error) || t(TK.somethingWentWrong)));
            } finally {
                setReportForEmailPdf(null);
                setSendingEmailItemId(null);
            }
        };

        send();
    }, [clientId, dispatch, reportForEmailPdf, t]);

    const closeDeleteModal = useCallback(() => {
        setDeletingFileId(undefined)
        setDeletingReportId(undefined)
    }, [setDeletingFileId])

    const handleDeleteConfirmation = useCallback(() => {
        if(deletingFileId) {
            dispatch(deleteEntity('files', deletingFileId, id => deleteClientFileAsync(clientId, id)))
        }
        if(deletingReportId) {
            dispatch(deleteEntity('reports', deletingReportId, id => deleteClientReportAsync(clientId, id)))
        }
    }, [deletingFileId, deletingReportId, clientId])

    useEffect(() => setDeletingFileId(undefined), [files.length]) // Close delete modal
    useEffect(() => setDeletingReportId(undefined), [reports.length]) // Close delete modal

    const activeTasks = useMemo(
        () => tasks
            .filter(task => task.status === TaskItemStatus.Pending)
            .sort((a, b) => a.dueDate > b.dueDate ? 1 : -1),
        [tasks]);
    const hasScopedManagementAccess = useMemo(() => hasVisibleTaskManagementScope(tasks, myUser), [tasks, myUser]);

    const historyTasks = useMemo(
        () => showActiveTasksSection
            ? tasks.filter(task => task.status !== TaskItemStatus.Pending)
            : tasks,
        [showActiveTasksSection, tasks]);

    const handleOpenFileShare = useCallback((file: ClientFile) => {
        setSharingItem({ id: file.id, type: 'file', share: file.share });
    }, []);

    const handleOpenReportShare = useCallback((report: Report) => {
        // When no share snapshot exists yet, seed defaults from the template so the modal
        // shows the same sharing configuration the template was configured with.
        const share: ShareOptions | undefined = report.share ?? (report.template ? {
            shareWithClient: report.template.shareWithClient || undefined,
            shareWithProfessionalsWithService: report.template.availableForAllAppointmentTypes
                ? null
                : (report.template.availableForAppointmentTypes ?? []),
            shareWithAdministratives: report.template.availableForAppointmentsManager || undefined,
        } : undefined);
        setSharingItem({ id: report.id, type: 'report', share });
    }, []);

    const handleSaveShare = useCallback(async (share: ShareOptions) => {
        if (!sharingItem) return;
        try {
            if (sharingItem.type === 'file') {
                await updateClientFileShareAsync(clientId, sharingItem.id, share);
            } else {
                await updateClientReportShareAsync(clientId, sharingItem.id, share);
            }
            dispatch(fetchClientReportsAndFiles(clientId));
        } catch (error) {
            dispatch(alertError(getErrorMessage(error) || t(TK.somethingWentWrong)));
        }
    }, [sharingItem, clientId, dispatch, t]);

    const listItems = useMemo(
        () => [
            ...reports.map(report => ({
                id: report.id,
                key: `report-${report.id}`,
                date: report.creationDate,
                createdBy: report.createdBy,
                text: `${report.creationDate?.substr(0, 10)} - ${report.name}`,
                subtext: report.professionalName?.length ? report.professionalName : report.createdBy,
                handleClick: report.values ? handleReportClick(report) : undefined,
                handleDelete: report.values ? () => setDeletingReportId(report.id) : undefined,
                handleToggleShare: report.values ? () => handleOpenReportShare(report) : undefined,
                shareWithClient: !!(report.share?.shareWithClient || report.share?.shareWithAdministratives || report.share?.shareWithProfessionalsWithService?.length),
                report: report,
            })),
            ...files.map(file => ({
                id: file.id,
                key: `file-${file.id}`,
                date: file.creationDate,
                createdBy: file.createdBy,
                href: file.url,
                text: file.documentSettings?.name
                    ? `${file.creationDate?.substr(0, 10)} - (${file.documentSettings.name}) ${file.fileName}`
                    : `${file.creationDate?.substr(0, 10)} - ${file.fileName}`,
                subtext: file.createdByName?.length ? file.createdByName : file.createdBy,
                handleDelete: file.url ? () => setDeletingFileId(file.id) : undefined,
                handleToggleShare: file.url ? () => handleOpenFileShare(file) : undefined,
                shareWithClient: !!(file.share?.shareWithClient || file.share?.shareWithAdministratives || file.share?.shareWithProfessionalsWithService?.length),
                isPdf: file.fileName?.toLowerCase().endsWith('.pdf'),
                isImage: isImageFile(file.fileName),
                fileName: file.fileName,
                documentSettings: file.documentSettings as DocumentSettings | undefined,
            })),
            ...historyTasks.map(task => ({
                id: task.id,
                key: `task-${task.id}`,
                date: task.createdAt,
                createdBy: task.createdBy,
                text: `${task.createdAt?.substr(0, 10)} - ${t(getTaskTypeTranslationKey(task.type))}${task.title ? ` - ${task.title}` : ''}`,
                subtext: task.assignedUserName?.length ? task.assignedUserName : task.createdBy,
                task,
            })),
            ...surveyHistory.map(historyItem => ({
                id: historyItem.id,
                key: `survey-${historyItem.id}`,
                date: historyItem.submittedAt ?? historyItem.sentAt,
                createdBy: historyItem.professionalName ?? '',
                text: `${(historyItem.submittedAt ?? historyItem.sentAt)?.substr(0, 10)} - ${historyItem.surveyName || t(TK.survey)}`,
                subtext: getSurveyHistorySubtext(historyItem),
                surveyHistory: historyItem,
            })),
            ...prescriptions.map(prescription => ({
                id: prescription.id,
                key: `prescription-${prescription.id}`,
                date: prescription.creationDate,
                createdBy: prescription.professionalName ?? '',
                text: `${prescription.creationDate?.substr(0, 10)} - ${t(TK.prescription)} #${prescription.numeroReceitaLocal}`,
                subtext: prescription.professionalName ?? '',
                prescription,
            })),
        ].sort((a, b) => a.date! > b.date! ? -1 : 1),
        [reports, files, historyTasks, handleReportClick, surveyHistory, t, getSurveyHistorySubtext, prescriptions, handleOpenReportShare, handleOpenFileShare])

    // Build filter options from actual data in the list
    const filterOptions = useMemo(() => {
        const reportOpts = new Map<string, FilterTypeOption>();
        const fileOpts = new Map<string, FilterTypeOption>();
        const taskOpts = new Map<string, FilterTypeOption>();
        const surveyOpts = new Map<string, FilterTypeOption>();
        let hasPrescriptions = false;

        for (const item of listItems) {
            if ('report' in item) {
                const id = item.report.templateId ?? '';
                if (!reportOpts.has(id)) {
                    const settings = reportsSettings.find(rs => rs.templateId === id);
                    reportOpts.set(id, { id, name: item.report.name, icon: settings?.icon, colorCode: settings?.colorCode, kind: 'report' });
                }
            } else if ('task' in item) {
                const id = `task-${item.task.type ?? 'none'}`;
                if (!taskOpts.has(id)) {
                    taskOpts.set(id, {
                        id,
                        name: t(getTaskTypeTranslationKey(item.task.type)),
                        kind: 'task',
                        taskType: item.task.type,
                    });
                }
            } else if ('surveyHistory' in item) {
                surveyOpts.set('survey-history', { id: 'survey-history', name: t(TK.surveys), kind: 'survey' });
            } else if ('prescription' in item) {
                hasPrescriptions = true;
            } else {
                const settings = documentsSettings.find(d => d.id === item.documentSettings?.id);
                const id = item.documentSettings?.id ?? '';
                if (!fileOpts.has(id)) {
                    fileOpts.set(id, { id: id, name: item.documentSettings?.name ?? t(TK.file), icon: settings?.icon, colorCode: settings?.colorCode, kind: 'file' });
                }
            }
        }

        return {
            reports: [...reportOpts.values()].sort((a, b) => a.name.localeCompare(b.name)),
            files: [...fileOpts.values()].sort((a, b) => a.name.localeCompare(b.name)),
            tasks: [...taskOpts.values()].sort((a, b) => a.name.localeCompare(b.name)),
            surveys: [...surveyOpts.values()],
            prescriptions: hasPrescriptions
                ? [{ id: 'prescription', name: t(TK.prescriptions), kind: 'prescription' as const }]
                : [],
        };
    }, [documentsSettings, listItems, reportsSettings, t]);

    const totalFilterOptions = filterOptions.reports.length + filterOptions.files.length + filterOptions.tasks.length + filterOptions.surveys.length + filterOptions.prescriptions.length;

    const availableReportTemplates = useMemo(() => {
        return reportsSettings
            .filter(r =>
                (myProfessional && (r.availableForAllAppointmentTypes || r.availableForAppointmentTypes.some(t => (myProfessional.capabilities ?? []).includes(t))))
                || r.availableForAppointmentsManager);
    }, [reportsSettings, myProfessional]);

    const availableDocumentTypes = useMemo(() => {
        return [genericFileSettings(t), ...documentsSettings]
    }, [documentsSettings, t]);

    const availableTaskTypes = useMemo(() => {
        if (!canCreateTask) return [];
        return taskTypesForCreation;
    }, [canCreateTask]);

    const canCreatePrescription = Boolean(features.includes(FeatureEnum.Prescriptions) && myProfessional?.id);
    const hasAddOptions = availableReportTemplates.length > 0 || availableDocumentTypes.length > 0 || availableTaskTypes.length > 0 || canCreatePrescription;
    const canSendSurveys = Boolean(
        features.includes(FeatureEnum.Surveys)
        && myUser?.permissions.some(p =>
            p === PermissionEnum.Administrator
            || p === PermissionEnum.ClientsManagement
            || p === PermissionEnum.MyClientsManagement),
    );

    const handleAddReportClick = useCallback((template: ReportTemplateData) => {
        setAddAnchor(null);
        if (!client) return;
        dispatch(createReport(template, client, appointment));
    }, [dispatch, client]);

    const handleAddDocumentClick = useCallback((docName: string) => {
        setAddAnchor(null);
        setUploadDocType(docName);
        setShowUploadModal(true);
    }, []);

    const handleAddTaskClick = useCallback((taskType: TaskItemType) => {
        setAddAnchor(null);
        setTaskTypeToCreate(taskType);
        setShowTaskCreateModal(true);
    }, []);

    const updateTask = useCallback(async (task: TaskItemData, status: TaskItemStatus, dismissReason?: string, notes?: string) => {
        if (!canUpdateTask(task, myUser, hasScopedManagementAccess)) return;

        setUpdatingTask(true);
        try {
            await updateTaskStatusAsync(task.id, {
                status,
                dismissReason,
                notes,
            });
            await loadClientTasks();
        } finally {
            setUpdatingTask(false);
        }
    }, [hasScopedManagementAccess, loadClientTasks, myUser]);

    const openTaskDetails = useCallback((task: TaskItemData) => {
        setSelectedTask(task);
        setDetailsNotes(task.notes ?? '');
    }, []);

    const filteredItems = useMemo(() => {
        if (selectedTypeIds.size === 0) return listItems;
        return listItems.filter(item => {
            if ('report' in item) return selectedTypeIds.has(item.report.templateId ?? '');
            if ('task' in item) return selectedTypeIds.has(`task-${item.task.type ?? 'none'}`);
            if ('surveyHistory' in item) return selectedTypeIds.has('survey-history');
            if ('prescription' in item) return selectedTypeIds.has('prescription');
            return selectedTypeIds.has(item.documentSettings?.id ?? '');
        });
    }, [listItems, selectedTypeIds]);

    const toggleTypeFilter = useCallback((id: string) => {
        setSelectedTypeIds(prev => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id); else next.add(id);
            writeFilterCookie(next);
            return next;
        });
    }, []);

    const clearTypeFilter = useCallback(() => {
        const empty = new Set<string>();
        writeFilterCookie(empty);
        setSelectedTypeIds(empty);
    }, []);

    const createdByMeRecently = (item: {date?: string, createdBy?: string}) => {
        return myUser
            && item.date && item.createdBy
            && item.createdBy === myUser.username
            && daysBetween(new Date(), new Date(item.date)) <= 1
    }

    const taskStatusTimestamp = useCallback((task: TaskItemData) => {
        if (!task.completedAt || task.status === TaskItemStatus.Pending) {
            return undefined;
        }

        return `${t(getTaskStatusTranslationKey(task.status))}: ${moment(task.completedAt).format('YYYY-MM-DD HH:mm')}`;
    }, [t]);

    return <>
            {showActiveTasksSection && activeTasks.length > 0 && (
                <div style={{ marginBottom: 'var(--spacer-S)' }}>
                    <Typography block>
                        <b>{t(TK.activeTasks)}</b>
                    </Typography>
                    <ListGroup>
                        {activeTasks.map((task, idx) => {
                            const ActiveTaskIcon = getTaskTypeIcon(task.type);
                            const canAct = canUpdateTask(task, myUser, hasScopedManagementAccess);
                            return (
                            <ListGroupItem key={`active-task-${task.id}`} id={`active-task-item-${idx}`} style={{display: 'flex', gap: 'var(--spacer-XS)'}}>
                                <ActiveTaskIcon />
                                <div style={{display: 'flex', alignItems: 'flex-start', gap: 'var(--spacer-XXS)', flex: 1, minWidth: 0}}>
                                    <ActiveTaskSummaryButton color="link" onClick={() => openTaskDetails(task)}>
                                        <div style={{display: 'flex', flexDirection: 'column', minWidth: 0}}>
                                            <span>
                                                {moment(task.dueDate).format('YYYY-MM-DD HH:mm')} - {t(getTaskTypeTranslationKey(task.type))}
                                                {task.title ? ` - ${task.title}` : ''}
                                            </span>
                                            <span style={{fontSize: '0.8em', color: 'var(--text-muted)'}}>
                                                {task.assignedUserName?.length ? task.assignedUserName : task.createdBy}
                                            </span>
                                            {!!task.notes?.trim().length && (
                                                <span style={{fontSize: '0.8em', color: 'var(--text-muted)'}}>
                                                    {t(TK.notes)}: {task.notes}
                                                </span>
                                            )}
                                        </div>
                                    </ActiveTaskSummaryButton>
                                    {canAct && (
                                        <ActiveTaskActions>
                                            <ActiveTaskActionButton size="small" disabled={isUpdatingTask} onClick={() => setCompleteTask(task)}>
                                                <CheckIcon fontSize="small" />
                                            </ActiveTaskActionButton>
                                            <ActiveTaskActionButton size="small" disabled={isUpdatingTask} onClick={() => updateTask(task, TaskItemStatus.Dismissed, TaskDismissReasons.notApplicable)}>
                                                <ClearIcon fontSize="small" />
                                            </ActiveTaskActionButton>
                                        </ActiveTaskActions>
                                    )}
                                </div>
                            </ListGroupItem>
                            );
                        })}
                    </ListGroup>
                </div>
            )}

            {showHistoryTitle && (
                <Typography block>
                    <b>{t(TK.history)}</b>
                </Typography>
            )}

            {(totalFilterOptions > 1 || hasAddOptions || (canSendSurveys && sendSurveyAction.canRenderAction)) && (
                <FilterBar>
                    {totalFilterOptions > 1 && (
                        <FilterButton
                            id="files-filter-button"
                            $active={selectedTypeIds.size > 0}
                            onClick={(e: React.MouseEvent<HTMLButtonElement>) => setFilterAnchor(e.currentTarget)}
                            size="small"
                        >
                            <FilterListIcon fontSize="small" />
                            {selectedTypeIds.size > 0 && <FilterBadge>{selectedTypeIds.size}</FilterBadge>}
                        </FilterButton>
                    )}
                    {canSendSurveys && sendSurveyAction.canRenderAction && (
                        <AddButton
                            onClick={() => {
                                if (!sendSurveyAction.canSendSurvey) return;
                                sendSurveyAction.openSendSurveyModal();
                            }}
                            disabled={!sendSurveyAction.canSendSurvey}
                            title={sendSurveyAction.canSendSurvey ? t(TK.sendSurvey) : (sendSurveyAction.sendSurveyDisabledMessage ?? t(TK.clientContactRequiredForSurvey))}
                            style={{ opacity: sendSurveyAction.canSendSurvey ? 1 : 0.5, cursor: sendSurveyAction.canSendSurvey ? 'pointer' : 'not-allowed' }}
                        >
                            <Assignment style={{ fontSize: '1rem' }} />
                            {t(TK.sendSurvey)}
                        </AddButton>
                    )}
                    {onOpenAiScriber && (
                        <AiButton onClick={onOpenAiScriber} title={t(TK.aiScriberFillReport)}>
                            <MicIcon style={{ fontSize: '1rem' }} />
                            {t(TK.aiScriberFillReport)}
                        </AiButton>
                    )}
                    {hasAddOptions && (
                        <AddButton onClick={(e: React.MouseEvent<HTMLButtonElement>) => setAddAnchor(e.currentTarget)}>
                            <AddIcon style={{ fontSize: '1rem' }} />
                            {t(TK.add)}
                        </AddButton>
                    )}
                </FilterBar>
            )}

            {!loading && filteredItems.length === 0
                ? <Typography><i>{t(TK.noReportCreatedYet)}</i></Typography>
                : <ListGroup>
                    { filteredItems.map((item, idx) => {
                        const reportSettings = 'report' in item ? reportsSettings.find(rs => rs.templateId === item.report.templateId) : undefined
                        const FileIcon = ('href' in item && getIconComponent(item.documentSettings?.icon)) || AttachFile;
                        const fileColor = 'href' in item ? item.documentSettings?.colorCode : undefined;
                        const ReportIcon = getIconComponent(reportSettings?.icon) || Assignment;
                        const reportColor = reportSettings?.colorCode;
                        const TaskIcon = getTaskTypeIcon('task' in item ? item.task.type : undefined);
                        const canSendDocumentByEmail = Boolean(client?.email);
                        const sendEmailTooltip = canSendDocumentByEmail ? t(TK.sendDocumentByEmail) : t(TK.clientHasNoEmail);
                        const isSendingThisItem = sendingEmailItemId === `file-${item.id}` || sendingEmailItemId === `report-${item.id}`;
                        return (
                            <ListGroupItem key={item.key} id={`reports-item-${idx}`} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                { 'href' in item
                                    ? <div
                                        style={{whiteSpace: 'nowrap', overflow: 'auto', display: 'flex', gap: 'var(--spacer-XS)'}}
                                        onMouseEnter={(item.isPdf || item.isImage) ? () => handleFileMouseEnter(item.id) : undefined}
                                        onMouseLeave={(item.isPdf || item.isImage) ? handleFileMouseLeave : undefined}
                                    >
                                        <FileIcon style={{ color: fileColor }} />
                                        <div style={{display: 'flex', flexDirection: 'column'}}>
                                            {item.href ? (
                                                <NavLink
                                                    id={`reports-item-${idx}-link`}
                                                    style={{padding: 0, display: 'inline'}}
                                                    href={item.href}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {item.text}
                                                </NavLink>
                                            ) : <span>{item.text}</span>}
                                            <span style={{fontSize: '0.8em', color: 'var(--text-muted)'}}>{item.subtext}</span>
                                        </div>
                                        {item.href && item.isPdf && (
                                            <Popover
                                                placement="right"
                                                isOpen={previewFileId === item.id}
                                                target={`reports-item-${idx}-link`}
                                                toggle={handleFileMouseLeave}
                                                className="preview-popover"
                                            >
                                                <PopoverBody>
                                                    <PdfPreview url={item.href} />
                                                </PopoverBody>
                                            </Popover>
                                        )}
                                        {item.href && item.isImage && (
                                            <Popover
                                                placement="right"
                                                isOpen={previewFileId === item.id}
                                                target={`reports-item-${idx}-link`}
                                                toggle={handleFileMouseLeave}
                                                className="preview-popover"
                                            >
                                                <PopoverBody>
                                                    <ImagePreview url={item.href} fileName={item.fileName ?? ''} />
                                                </PopoverBody>
                                            </Popover>
                                        )}
                                    </div> : 'task' in item
                                    ? <div style={{whiteSpace: 'nowrap', overflow: 'auto', display: 'flex', gap: 'var(--spacer-XS)'}}>
                                        <TaskIcon />
                                        <div style={{display: 'flex', flexDirection: 'column', minWidth: 0}}>
                                            <span>{item.text}</span>
                                            <span style={{fontSize: '0.8em', color: 'var(--text-muted)'}}>{item.subtext}</span>
                                            {!!item.task.notes?.trim().length && (
                                                <span style={{fontSize: '0.8em', color: 'var(--text-muted)'}}>{t(TK.notes)}: {item.task.notes}</span>
                                            )}
                                            {!!taskStatusTimestamp(item.task) && (
                                                <span style={{fontSize: '0.8em', color: 'var(--text-muted)'}}>{taskStatusTimestamp(item.task)}</span>
                                            )}
                                        </div>
                                    </div> : 'surveyHistory' in item
                                    ? <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacer-XXS)', width: '100%'}}>
                                        <div style={{display: 'flex', alignItems: 'flex-start', gap: 'var(--spacer-XS)'}}>
                                            <Ballot style={{ fontSize: '1.1rem', color: 'var(--appBlue)', marginTop: '0.15rem', flexShrink: 0 }} />
                                            <AppButton
                                                color="link"
                                                style={{padding: 0, textAlign: 'left', justifyContent: 'flex-start'}}
                                                onClick={() => setExpandedSurveyHistoryId(expandedSurveyHistoryId === item.id ? null : item.id)}
                                            >
                                                <span>{item.text}</span>
                                            </AppButton>
                                        </div>
                                        {!!item.subtext && (
                                            <span style={{fontSize: '0.8em', color: 'var(--text-muted)'}}>{item.subtext}</span>
                                        )}
                                        <SurveyHistoryMeta>
                                            <SurveyHistoryStatus submitted={item.surveyHistory.isSubmitted}>
                                                {item.surveyHistory.isSubmitted ? t(TK.surveyStatusCompleted) : t(TK.surveyAwaitingResponse)}
                                            </SurveyHistoryStatus>
                                            <SurveyHistoryMetaText>
                                                {t(TK.surveySentAt)}: {moment(item.surveyHistory.sentAt).format('YYYY-MM-DD HH:mm')}
                                            </SurveyHistoryMetaText>
                                            {item.surveyHistory.submittedAt && (
                                                <SurveyHistoryMetaText>
                                                    {t(TK.surveySubmittedAt)}: {moment(item.surveyHistory.submittedAt).format('YYYY-MM-DD HH:mm')}
                                                </SurveyHistoryMetaText>
                                            )}
                                            {item.surveyHistory.isAnonymousSubmission && (
                                                <SurveyHistoryMetaText>{t(TK.surveySubmittedAnonymously)}</SurveyHistoryMetaText>
                                            )}
                                        </SurveyHistoryMeta>
                                        {expandedSurveyHistoryId === item.id && (
                                            <SurveyHistoryDetails>
                                                {item.surveyHistory.isAnonymousSubmission ? (
                                                    <SurveyHistoryHint>
                                                        <VisibilityOffIcon fontSize="small" />
                                                        <span>{t(TK.surveyAnonymousAnswersHidden)}</span>
                                                    </SurveyHistoryHint>
                                                ) : (
                                                    Object.entries(item.surveyHistory.values || {}).map(([key, value]) => (
                                                        <SurveyHistoryAnswer key={`${item.id}-${key}`}>
                                                            <b>{getSurveyFieldLabel(item.surveyHistory.surveyId, key)}:</b> {value || '-'}
                                                        </SurveyHistoryAnswer>
                                                    ))
                                                )}
                                                {!item.surveyHistory.isSubmitted && (
                                                    <SurveyHistoryHint>
                                                        <span>{t(TK.surveyAwaitingResponse)}</span>
                                                    </SurveyHistoryHint>
                                                )}
                                            </SurveyHistoryDetails>
                                        )}
                                    </div> : 'prescription' in item
                                    ? <div style={{display: 'flex', gap: 'var(--spacer-XS)', alignItems: 'flex-start', flex: 1, cursor: 'pointer'}} onClick={() => setResultPrescription(item.prescription)}>
                                        <LocalPharmacy style={{ color: 'var(--appBlue)', flexShrink: 0 }} />
                                        <div style={{display: 'flex', flexDirection: 'column', minWidth: 0}}>
                                            <span>{item.text}</span>
                                            <span style={{fontSize: '0.8em', color: 'var(--text-muted)'}}>{item.subtext}</span>
                                            <span style={{fontSize: '0.75em', color: item.prescription.state === PrescriptionState.Registered ? 'var(--success-color)' : item.prescription.state === PrescriptionState.Error ? 'var(--danger)' : 'var(--text-muted)'}}>
                                                {item.prescription.state === PrescriptionState.Registered ? (item.prescription.numeroReceita ?? t(TK.prescriptionStateRegistered)) : item.prescription.state === PrescriptionState.Error ? t(TK.prescriptionStateError) : item.prescription.state === PrescriptionState.Cancelled ? t(TK.prescriptionStateCancelled) : t(TK.prescriptionStatePending)}
                                            </span>
                                        </div>
                                    </div> : <div
                                        style={{whiteSpace: 'nowrap', overflow: 'auto', display: 'flex', gap: 'var(--spacer-XS)'}}
                                        onMouseEnter={() => handleReportMouseEnter(item.id)}
                                        onMouseLeave={handleReportMouseLeave}
                                    >
                                        <ReportIcon style={{ color: reportColor }} />
                                        <div style={{display: 'flex', flexDirection: 'column'}}>
                                            {item.handleClick ? (
                                                <AppButton
                                                    id={`reports-item-${idx}-button`}
                                                    style={{padding: 0}}
                                                    color="link"
                                                    onClick={item.handleClick}
                                                >
                                                    {item.text}
                                                </AppButton>
                                            ) : <span>{item.text}</span>}
                                            <span style={{fontSize: '0.8em', color: 'var(--text-muted)'}}>{item.subtext}</span>
                                        </div>
                                        {!reportSettings?.showReportInline && item.report.values && (
                                            <Popover
                                                placement="right"
                                                isOpen={previewReportId === item.id}
                                                target={`reports-item-${idx}-button`}
                                                toggle={handleReportMouseLeave}
                                                className="preview-popover"
                                            >
                                                <PopoverBody>
                                                    <ReportPreview
                                                        report={item.report}
                                                        template={reportSettings}
                                                    />
                                                </PopoverBody>
                                            </Popover>
                                        )}
                                        {reportSettings?.showReportInline && <>
                                            <hr style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}/>
                                            <div style={{marginLeft: '2.4rem', maxHeight: '140px', overflow: 'auto'}}>
                                                <ReportPreview
                                                    report={item.report}
                                                    template={reportSettings}
                                                />
                                            </div>
                                        </>}
                                    </div>
                                }
                                <div style={{display: 'flex', alignItems: 'center', gap: 'var(--spacer-XS)'}}>
                                    {'handleToggleShare' in item && item.handleToggleShare && (
                                        <Tooltip title={t(TK.shareWithClientTooltip)}>
                                            <IconButton
                                                size="small"
                                                onClick={item.handleToggleShare}
                                                style={{ color: item.shareWithClient ? 'var(--appGreen)' : 'var(--text-muted)' }}
                                            >
                                                {item.shareWithClient ? <ShareIcon fontSize="small" /> : <VisibilityOffIcon fontSize="small" />}
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    {'report' in item && (
                                        <DocumentEmailButton
                                            id={`reports-item-${idx}-send-email-button`}
                                            disabled={!canSendDocumentByEmail}
                                            sending={isSendingThisItem}
                                            tooltip={sendEmailTooltip}
                                            onClick={() => handleSendReportByEmail(item.report.id)}
                                        />
                                    )}
                                    {'href' in item && (
                                        <DocumentEmailButton
                                            id={`reports-item-${idx}-send-email-button`}
                                            disabled={!canSendDocumentByEmail}
                                            sending={isSendingThisItem}
                                            tooltip={sendEmailTooltip}
                                            onClick={() => handleSendFileByEmail(item.id)}
                                        />
                                    )}
                                    { (isAdmin || createdByMeRecently(item)) && 'handleDelete' in item && item.handleDelete &&
                                        <AppButton
                                            id={`reports-item-${idx}-delete-button`}
                                            color="link"
                                            onClick={item.handleDelete}
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                minWidth: '3rem',
                                                height: '3rem',
                                                padding: 0,
                                                color: 'var(--danger-color)',
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                            }}
                                        >
                                            <Delete/>
                                        </AppButton>
                                }
                            </div>
                        </ListGroupItem>)
                        })
                    }
                </ListGroup>
            }

            { loading ? <Typography><i>{t(TK.loading)}...</i></Typography> : null }

            <MuiPopover
                open={!!filterAnchor}
                anchorEl={filterAnchor}
                onClose={() => setFilterAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <FilterMenuContent>
                    {filterOptions.reports.length > 0 && (
                        <>
                            <FilterSectionTitle>{t(TK.reports)}</FilterSectionTitle>
                            {filterOptions.reports.map(opt => {
                                const OptIcon = getIconComponent(opt.icon) || Assignment;
                                const isSelected = selectedTypeIds.has(opt.id);
                                return (
                                    <FilterOption key={opt.id} $selected={isSelected} onClick={() => toggleTypeFilter(opt.id)}>
                                        <input type="checkbox" checked={isSelected} onChange={() => {}} style={{cursor: 'pointer', flexShrink: 0}} />
                                        <OptIcon style={{ color: opt.colorCode, fontSize: '1.1rem' }} />
                                        <span>{opt.name}</span>
                                    </FilterOption>
                                );
                            })}
                        </>
                    )}
                    {filterOptions.files.length > 0 && (
                        <>
                            <FilterSectionTitle>{t(TK.files)}</FilterSectionTitle>
                            {filterOptions.files.map(opt => {
                                const OptIcon = getIconComponent(opt.icon) || AttachFile;
                                const isSelected = selectedTypeIds.has(opt.id);
                                return (
                                    <FilterOption key={opt.id} $selected={isSelected} onClick={() => toggleTypeFilter(opt.id)}>
                                        <input type="checkbox" checked={isSelected} onChange={() => {}} style={{cursor: 'pointer', flexShrink: 0}} />
                                        <OptIcon style={{ color: opt.colorCode, fontSize: '1.1rem' }} />
                                        <span>{opt.name}</span>
                                    </FilterOption>
                                );
                            })}
                        </>
                    )}
                    {filterOptions.tasks.length > 0 && (
                        <>
                            <FilterSectionTitle>{t(TK.tasks)}</FilterSectionTitle>
                            {filterOptions.tasks.map(opt => {
                                const isSelected = selectedTypeIds.has(opt.id);
                                const OptTaskIcon = getTaskTypeIcon(opt.taskType);
                                return (
                                    <FilterOption key={opt.id} $selected={isSelected} onClick={() => toggleTypeFilter(opt.id)}>
                                        <input type="checkbox" checked={isSelected} onChange={() => {}} style={{cursor: 'pointer', flexShrink: 0}} />
                                        <OptTaskIcon style={{ fontSize: '1.1rem' }} />
                                        <span>{opt.name}</span>
                                    </FilterOption>
                                );
                            })}
                        </>
                    )}
                    {filterOptions.surveys.length > 0 && (
                        <>
                            <FilterSectionTitle>{t(TK.surveys)}</FilterSectionTitle>
                            {filterOptions.surveys.map(opt => {
                                const isSelected = selectedTypeIds.has(opt.id);
                                return (
                                    <FilterOption key={opt.id} $selected={isSelected} onClick={() => toggleTypeFilter(opt.id)}>
                                        <input type="checkbox" checked={isSelected} onChange={() => {}} style={{cursor: 'pointer', flexShrink: 0}} />
                                        <Ballot style={{ fontSize: '1.1rem', color: 'var(--appBlue)' }} />
                                        <span>{opt.name}</span>
                                    </FilterOption>
                                );
                            })}
                        </>
                    )}
                    {filterOptions.prescriptions.length > 0 && (
                        <>
                            <FilterSectionTitle>{t(TK.prescriptions)}</FilterSectionTitle>
                            {filterOptions.prescriptions.map(opt => {
                                const isSelected = selectedTypeIds.has(opt.id);
                                return (
                                    <FilterOption key={opt.id} $selected={isSelected} onClick={() => toggleTypeFilter(opt.id)}>
                                        <input type="checkbox" checked={isSelected} onChange={() => {}} style={{cursor: 'pointer', flexShrink: 0}} />
                                        <LocalPharmacy style={{ fontSize: '1.1rem', color: 'var(--appBlue)' }} />
                                        <span>{opt.name}</span>
                                    </FilterOption>
                                );
                            })}
                        </>
                    )}
                    {selectedTypeIds.size > 0 && (
                        <ClearFilterButton onClick={clearTypeFilter}>✕ {t(TK.filter)}</ClearFilterButton>
                    )}
                </FilterMenuContent>
            </MuiPopover>

            <MuiPopover
                open={!!addAnchor}
                anchorEl={addAnchor}
                onClose={() => setAddAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <FilterMenuContent>
                    {availableReportTemplates.length > 0 && (
                        <>
                            <FilterSectionTitle>{t(TK.reports)}</FilterSectionTitle>
                            {availableReportTemplates.sort((a, b) => a.name.localeCompare(b.name)).map(template => {
                                const OptIcon = getIconComponent(template.icon) || Assignment;
                                return (
                                    <AddMenuOption key={template.templateId} onClick={() => handleAddReportClick(template)}>
                                        <OptIcon style={{ color: template.colorCode, fontSize: '1.1rem' }} />
                                        <span>{template.name}</span>
                                    </AddMenuOption>
                                );
                            })}
                        </>
                    )}
                    {availableDocumentTypes.length > 0 && (
                        <>
                            <FilterSectionTitle>{t(TK.files)}</FilterSectionTitle>
                            {availableDocumentTypes.sort((a, b) => a.name.localeCompare(b.name)).map(doc => {
                                const OptIcon = getIconComponent(doc.icon) || AttachFile;
                                return (
                                    <AddMenuOption key={doc.id} onClick={() => handleAddDocumentClick(doc.name)}>
                                        <OptIcon style={{ color: doc.colorCode, fontSize: '1.1rem' }} />
                                        <span>{doc.name}</span>
                                    </AddMenuOption>
                                );
                            })}
                        </>
                    )}
                    {availableTaskTypes.length > 0 && (
                        <>
                            <FilterSectionTitle>{t(TK.tasks)}</FilterSectionTitle>
                            {availableTaskTypes.map(taskType => {
                                const AddTaskIcon = getTaskTypeIcon(taskType);
                                return (
                                    <AddMenuOption key={taskType} onClick={() => handleAddTaskClick(taskType)}>
                                        <AddTaskIcon style={{ fontSize: '1.1rem' }} />
                                        <span>{t(getTaskTypeTranslationKey(taskType))}</span>
                                    </AddMenuOption>
                                );
                            })}
                        </>
                    )}
                    {canCreatePrescription && (
                        <>
                            <FilterSectionTitle>{t(TK.prescriptions)}</FilterSectionTitle>
                            <AddMenuOption onClick={() => { setAddAnchor(null); setShowCreatePrescription(true); }}>
                                <LocalPharmacy style={{ fontSize: '1.1rem', color: 'var(--appBlue)' }} />
                                <span>{t(TK.prescriptionNew)}</span>
                            </AddMenuOption>
                        </>
                    )}
                </FilterMenuContent>
            </MuiPopover>

            <TaskCreateModal
                show={showTaskCreateModal}
                onClose={() => setShowTaskCreateModal(false)}
                onCreated={loadClientTasks}
                initialType={taskTypeToCreate}
                initialClientId={clientId}
                initialAssignedUserId={defaultTaskAssignedUserId}
                allowAssignedUserSelection={false}
                // users={users}
                clients={clients}
            />
            <Dialog open={selectedTask != null} onClose={() => setSelectedTask(null)} fullWidth maxWidth="sm">
                <DialogTitle>{t(TK.taskDetails)}</DialogTitle>
                <DialogContent>
                    <TaskDetailsBody>
                        <div><b>{selectedTask?.clientName || '-'}</b></div>
                        <div>{selectedTask?.title || '-'}</div>
                        <TextInputField
                            type="textarea"
                            value={detailsNotes}
                            onChange={setDetailsNotes}
                            placeholder={t(TK.notes)}
                        />
                        <TaskDetailsActions>
                            <AppButton color="light" onClick={() => setSelectedTask(null)}>
                                {t(TK.cancel)}
                            </AppButton>
                            <AppButton
                                color="danger"
                                disabled={!selectedTask || isUpdatingTask || !canUpdateTask(selectedTask, myUser, hasScopedManagementAccess)}
                                onClick={async () => {
                                    if (!selectedTask) return;
                                    await updateTask(selectedTask, TaskItemStatus.Dismissed, TaskDismissReasons.notApplicable, detailsNotes);
                                    setSelectedTask(null);
                                }}
                            >
                                {t(TK.dismissTask)}
                            </AppButton>
                            <AppButton
                                color="success"
                                disabled={!selectedTask || isUpdatingTask || !canUpdateTask(selectedTask, myUser, hasScopedManagementAccess)}
                                onClick={() => {
                                    if (!selectedTask) return;
                                    setCompleteTask({
                                        ...selectedTask,
                                        notes: detailsNotes,
                                    });
                                    setSelectedTask(null);
                                }}
                            >
                                {t(TK.completeTask)}
                            </AppButton>
                        </TaskDetailsActions>
                    </TaskDetailsBody>
                </DialogContent>
            </Dialog>
            <TaskCompleteDialog
                task={completeTask}
                onClose={() => setCompleteTask(null)}
                onCompleted={loadClientTasks}
            />

            <UploadFileModal
                clientId={clientId}
                show={showUploadModal}
                close={() => setShowUploadModal(false)}
                initialDocType={uploadDocType}
            />

            <Modal isOpen={!!deletingFileId || !!deletingReportId} toggle={closeDeleteModal}>
                <ModalHeader toggle={closeDeleteModal}>{t(TK.areYouSure)}</ModalHeader>
                <ModalBody>{t(TK.youRAboutToDelete)}</ModalBody>
                <ModalFooter>
                    <AppButton id="confirm-delete-button" color="danger" onClick={handleDeleteConfirmation}>{t(TK.delete)}</AppButton>{' '}
                    <AppButton id="cancel-delete-button" color="secondary" onClick={closeDeleteModal}>{t(TK.cancel)}</AppButton>
                </ModalFooter>
            </Modal>

            <SendSurveyModal
                isOpen={sendSurveyAction.showSendSurveyModal}
                onClose={sendSurveyAction.closeSendSurveyModal}
                onCreateForm={sendSurveyAction.redirectToCreateForm}
                onSelectedSurveyIdChanged={sendSurveyAction.setSelectedSurveyId}
                onSend={sendSurveyAction.sendSurvey}
                selectedSurveyDisabledMessage={sendSurveyAction.selectedSurveyDisabledMessage}
                selectedSurveyId={sendSurveyAction.selectedSurveyId}
                sendingSurvey={sendSurveyAction.sendingSurvey}
                surveys={sendSurveyAction.surveys}
            />

            {client && (
                <CreatePrescriptionModal
                    isOpen={showCreatePrescription}
                    client={client}
                    onClose={() => setShowCreatePrescription(false)}
                    onCreated={prescription => {
                        setShowCreatePrescription(false);
                        setResultPrescription(prescription);
                        loadClientTasks();
                    }}
                />
            )}

            <Dialog open={resultPrescription != null} onClose={() => setResultPrescription(null)} fullWidth maxWidth="sm">
                <DialogTitle>{t(TK.prescriptionNumber)} {resultPrescription?.numeroReceita ?? resultPrescription?.numeroReceitaLocal}</DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacer-S)', paddingTop: 'var(--spacer-XS)' }}>
                        <div>
                            <b>{t(TK.prescriptionState)}:</b>{' '}
                            <span style={{ color: resultPrescription?.state === PrescriptionState.Registered ? 'var(--success-color)' : resultPrescription?.state === PrescriptionState.Error ? 'var(--danger-color)' : 'var(--text-muted)' }}>
                                {resultPrescription?.state === PrescriptionState.Registered ? t(TK.prescriptionStateRegistered) : resultPrescription?.state === PrescriptionState.Error ? t(TK.prescriptionStateError) : t(TK.prescriptionStatePending)}
                            </span>
                        </div>
                        {resultPrescription?.numeroReceita && (
                            <div><b>{t(TK.prescriptionNumber)}:</b> {resultPrescription.numeroReceita}</div>
                        )}
                        {resultPrescription?.pinReceita && (
                            <div><b>{t(TK.prescriptionPinReceita)}:</b> {resultPrescription.pinReceita}</div>
                        )}
                        {resultPrescription?.pinDireitoOpcao && (
                            <div><b>{t(TK.prescriptionPinDireitoOpcao)}:</b> {resultPrescription.pinDireitoOpcao}</div>
                        )}
                        {resultPrescription?.dataReceita && (
                            <div><b>{t(TK.date)}:</b> {moment(resultPrescription.dataReceita).format('YYYY-MM-DD')}</div>
                        )}
                        {resultPrescription?.spmsResultCode && (
                            <div><b>{t(TK.prescriptionSpmsResultCode)}:</b> {resultPrescription.spmsResultCode}</div>
                        )}
                        {resultPrescription?.spmsResultMessage && (
                            <div><b>{t(TK.prescriptionSpmsResultMessage)}:</b> {resultPrescription.spmsResultMessage}</div>
                        )}
                        {resultPrescription?.lines && resultPrescription.lines.length > 0 && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacer-XS)' }}>
                                <b>{t(TK.prescriptionLines)}:</b>
                                {resultPrescription.lines.map((line, i) => (
                                    <div
                                        key={i}
                                        style={{
                                            border: 'var(--border-thin) solid var(--appLigthGrey)',
                                            borderRadius: 'var(--spacer-XS)',
                                            padding: 'var(--spacer-XS) var(--spacer-S)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 'var(--spacer-XXS)',
                                            fontSize: '0.9em',
                                        }}
                                    >
                                        <div><b>{line.substanciaActiva}</b>{line.dosagem ? ` — ${line.dosagem}` : ''}</div>
                                        {line.formaFarmaceutica && <div style={{ color: 'var(--text-muted)' }}>{line.formaFarmaceutica}{line.embalagem ? ` · ${line.embalagem}` : ''}</div>}
                                        <div style={{ color: 'var(--text-muted)' }}>{t(TK.prescriptionQuantidade)}: {line.quantidade}{line.instrucoes ? ` · ${line.instrucoes}` : ''}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </DialogContent>
                <ModalFooter>
                    <AppButton color="secondary" onClick={() => window.print()}>{t(TK.prescriptionPrint)}</AppButton>
                    <AppButton color="primary" onClick={() => setResultPrescription(null)}>{t(TK.close)}</AppButton>
                </ModalFooter>
            </Dialog>

            <ShareOptionsModal
                open={sharingItem != null}
                currentShare={sharingItem?.share}
                onClose={() => setSharingItem(null)}
                onSave={handleSaveShare}
            />
        </>
}
